export const arabicTranslations: Record<string, string> = {
  // Navigation
  'nav.home': 'الرئيسية',
  'nav.shop': 'منتجاتنا',
  'nav.about': 'من نحن',
  'nav.contact': 'اتصلي بنا',
  'nav.blog': 'المدونة',
  'nav.trackOrder': 'تتبع طلبي',

  'hero.badge.pdrn': 'تقنية PDRN',
  'hero.badge.glassSkin': 'تأثير Glass Skin',
  'hero.badge.korean': 'ابتكار كوري',
  'hero.title': 'عناية PDRN — DNA السلمون الكوري',
  'hero.subtitle': 'غيّري بشرتكِ مع سيروم PDRN، أقنعة القماش وكريم الكبسولات المثبتة سريرياً. احصلي على تأثير Glass Skin مع منتجات العناية بالبشرة PDRN الفاخرة المستخلصة من DNA السلمون.',
  'hero.cta': 'اكتشفي المجموعة',
  'hero.ctaSurvey': 'تشخيص بشرة مجاني',
  'hero.socialProof': 'محبوبة من أكثر من 10,000 من عاشقات العناية بالبشرة',
  'survey.bubbleTooltip': 'روتين مخصص + خصم 10%',

  'products.title': 'مجموعتنا',
  'products.subtitle': 'عناية كورية فاخرة بتقنية PDRN',
  'products.addToCart': 'أضيفي إلى السلة',
  'products.buyNow': 'اشتري الآن',
  'products.soldOut': 'نفدت الكمية',
  'products.save': 'عرض',
  'products.viewDetails': 'التفاصيل',
  'products.noProducts': 'لا توجد منتجات متاحة حالياً',
  'products.selectSize': 'اختاري الحجم',
  'products.quantity': 'الكمية',
  'products.inStock': 'متوفر',
  'products.outOfStock': 'نفدت الكمية',

  'upsell.title': 'أكملي الروتين',
  'upsell.savings': 'وفّري مع الطقم الكامل',
  'upsell.cta': 'ترقية إلى الطقم الكامل',
  'upsell.includes': 'روتين عناية كامل في حزمة واحدة',
  'upsell.badge': 'أكملي الروتين',
  'upsell.saveBadge': 'وفّري {amount}!',
  'upsell.whyBundle': 'لماذا تختارين الطقم الكامل؟',
  'upsell.whyBundleDesc': 'كل خطوة تبني على السابقة لنتائج مثالية',
  'upsell.includesSerum': 'سيروم التوهج الوردي',
  'upsell.includesCream': 'كريم الكبسولات الذكي',
  'upsell.includesMasks': 'علبة 10 أقنعة',
  'upsell.separatelyPrice': 'بشكل منفصل: {amount}',
  'upsell.serumTooltip': 'سيروم PDRN خفيف يعزز إنتاج الكولاجين، يقلل التجاعيد ويمنح توهج Glass Skin فوري.',
  'upsell.creamTooltip': 'تركيبة كبسولات مبتكرة مع PDRN، 5% نياسيناميد وكولاجين متحلل لترطيب عميق وشد البشرة.',
  'upsell.masksTooltip': '10 أقنعة قماشية مشبعة بسيروم PDRN مركّز لعلاج مكثف يمنح تأثير Glass Skin فوري.',

  'cart.title': 'سلة التسوق',
  'cart.empty': 'سلتكِ فارغة',
  'cart.itemCount': '{count} منتجات في السلة',
  'cart.total': 'المجموع',
  'cart.checkout': 'الدفع',
  'cart.continueShopping': 'تابعي التسوق',
  'cart.addedToCart': 'أُضيف إلى السلة!',
  'cart.couponPlaceholder': 'رمز الخصم',
  'cart.applyCoupon': 'تطبيق',
  'cart.couponApplied': 'تم تطبيق الخصم!',
  'cart.couponError': 'رمز غير صالح',
  'cart.removeCoupon': 'إزالة',
  'cart.freeShippingUnlocked': 'حصلتِ على شحن مجاني!',
  'cart.freeShippingRemaining': 'أضيفي {amount} إضافية للحصول على شحن مجاني',
  'cart.freeShippingThreshold': 'شحن مجاني للطلبات التي تزيد عن {amount}',
  'cart.completeRoutine': 'أكملي روتينكِ',
  'cart.bundleSave': 'وفّري {percent}%',
  'cart.quickAdd': 'أضيفي',

  'promo.b2g1': '🎁 أضيفي 3 منتجات للسلة — 1 منها مجاناً!',
  'promo.b2g1Cart': '🎁 عرض 2+1 مُفعّل! لكل 3 منتجات 1 مجاناً!',
  'promo.b2g1CartHint': 'أضيفي {count} أخرى للحصول على منتج مجاني! (يلزم 3 منتجات)',
  'promo.b2g1Saving': 'توفرين {amount} — المنتج الأرخص مجاني!',
  'promo.freeItem': '🎁 مجاني في العرض',

  'about.title': 'من نحن',
  'about.subtitle': 'العلم وراء الجمال الكوري',
  'about.pdrnTitle': 'علم العناية بـ PDRN',
  'about.pdrnDescription': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون — مكوّن ثوري في العناية الكورية بالبشرة. منتجات العناية PDRN لدينا تعزز تجديد الخلايا للحصول على تأثير Glass Skin مثالي.',
  'about.glassSkinDesc': 'احصلي على تأثير Glass Skin الكوري المطلوب مع توهج فوري.',
  'about.hydrationDesc': 'ترطيب عميق يدوم طوال اليوم، مع الحفاظ على الرطوبة المثبت سريرياً.',
  'about.antiAgingDesc': 'عززي إنتاج الكولاجين بشكل طبيعي لبشرة مشدودة وأكثر شباباً.',

  'footer.copyright': '© 2026 PDRN SKIN. جميع الحقوق محفوظة.',
  'footer.freeShipping': 'شحن مجاني للطلبات فوق {amount} (الإمارات)',
  'footer.securePayment': 'دفع آمن',
  'footer.support': 'دعم على مدار الساعة',
  'footer.description': 'عناية كورية فاخرة بتقنية PDRN الثورية. اختبري تأثير Glass Skin مع منتجاتنا العلمية.',
  'footer.sheetMasks': 'أقنعة القماش',
  'footer.serum': 'سيروم',
  'footer.cream': 'كريم',
  'footer.bundle': 'الطقم الكامل',
  'footer.faq': 'الأسئلة الشائعة',
  'footer.shippingReturns': 'الشحن والإرجاع',
  'footer.privacyPolicy': 'سياسة الخصوصية',
  'footer.termsOfService': 'شروط الاستخدام',
  'footer.returnPolicy': 'سياسة الإرجاع',
  'footer.contactSupport': 'نحن هنا من أجلك — أسئلة، حالة الطلب، مشاكل أو مساعدة في الشراء. تواصلي مع خدمة العملاء عبر',

  'common.verified': 'موثّقة',
  'common.before': 'قبل',
  'common.after': 'بعد',
  'common.loading': 'جاري التحميل...',
  'common.error': 'حدث خطأ',
  'common.noPhotoShared': 'لم تشارك العميلة صورة',

  'media.videoPlaceholder': 'عنصر نائب للفيديو',
  'media.gifPlaceholder': 'عنصر نائب لصورة GIF',
  'media.imagePlaceholder': 'عنصر نائب للصورة',

  'feature.hydration': '+100% ترطيب',
  'feature.glassSkin': 'تأثير Glass Skin',
  'feature.antiAging': 'مكافحة الشيخوخة',
  'feature.collagen': 'تعزيز الكولاجين',
  'feature.brightening': 'توحيد البشرة',

  'product.howToUse': 'طريقة الاستخدام',
  'product.ingredients': 'المكونات الرئيسية',
  'product.reviews': 'تقييمات العملاء',
  'product.results': 'نتائج حقيقية',
  'product.realResults': 'نتائج حقيقية',
  'product.beforeAfter': 'قبل وبعد',
  'product.faqTitle': 'أسئلة وأجوبة',
  'product.mediaGallery': 'معرض الوسائط',
  'product.freeShipping': 'شحن مجاني من {amount}',
  'product.secureCheckout': 'دفع آمن',
  'product.returns': 'إرجاع خلال 7 أيام',
  'product.koreanFormula': 'تركيبة كورية',
  'product.premiumIngredients': 'مكونات فاخرة',
  'product.backHome': 'العودة إلى الرئيسية',
  'product.notFound': 'المنتج غير موجود',
  'product.bestValue': 'أفضل قيمة',
  'product.bestseller': 'الأكثر مبيعاً',
  'product.reviewCount': '({count} تقييمات)',
  'product.crueltyFree': 'لم يُختبر على الحيوانات',
  'product.youMayAlsoLike': 'قد يعجبكِ أيضاً',
  'product.completeRoutine': 'أكملي روتين العناية بالبشرة',
  'product.moneyBack': 'استرداد المال خلال 7 أيام',
  'product.dermatologistTested': 'مختبر من أطباء الجلدية',
  'product.payWith': 'دفع آمن عبر',
  'product.specsTitle': 'تفاصيل المنتج',
  'product.specsVolume': 'الحجم',
  'product.specsSkinType': 'نوع البشرة',
  'product.specsTested': 'الاختبارات',
  'product.specsClinicallyTested': 'مختبر سريرياً',
  'product.specsShelfLife': 'مدة الصلاحية',
  'product.specsFreeOf': 'خالٍ من البارابين والسلفات والفثالات',
  'product.satisfactionGuarantee': 'ضمان الرضا 100%',
  'product.satisfactionDesc': 'جربي بدون مخاطرة مع ضماننا لاسترداد المال خلال 7 أيام',

  'beforeAfter.customer1': 'فاطمة',
  'beforeAfter.customer2': 'مريم',
  'beforeAfter.customer3': 'نورة',
  'beforeAfter.weeks3': '3 أسابيع من الاستخدام',
  'beforeAfter.weeks8': '8 أسابيع من الاستخدام',
  'beforeAfter.weeks12': '12 أسبوعاً من الاستخدام',

  'mobileCart.findRoutine': 'اكتشفي روتينكِ',

  'survey.buttonText': 'اكتشفي روتينكِ',
  'survey.title': 'تشخيص البشرة',
  'survey.subtitle': 'أجيبي على بعض الأسئلة القصيرة وسأختار لكِ الروتين المثالي',
  'survey.question': 'سؤال',
  'survey.back': 'رجوع',
  'survey.next': 'التالي',
  'survey.getResults': 'النتائج',
  'survey.resultsTitle': 'الروتين الذي اخترته لكِ',
  'survey.resultsSubtitle': 'بناءً على ما أخبرتِني، هذا ما أنصحكِ به',
  'survey.yourProfile': 'ملف بشرتكِ',
  'survey.recommended': 'موصى به لكِ',
  'survey.bundleNote': 'للحصول على أفضل النتائج، أنصحكِ بالطقم الكامل',
  'survey.howToUse': 'الروتين الذي اخترته لكِ',
  'survey.morning': 'صباحاً',
  'survey.evening': 'مساءً',
  'survey.expectedResults': 'النتائج المتوقعة',
  'survey.week': 'أسبوع',
  'survey.weeks': 'أسابيع',
  'survey.personalTips': 'نصائحي لكِ',
  'survey.retake': 'أعيدي الاختبار',
  'survey.shopNow': 'تسوّقي الآن',
  'survey.errorTooMany': 'طلبات كثيرة جداً. حاولي مرة أخرى لاحقاً.',
  'survey.errorGeneric': 'حدث خطأ ما. حاولي مرة أخرى.',
  'survey.yourPersonalizedRoutine': 'الروتين الذي اخترته لكِ',
  'survey.treatmentPlan': 'مدة العلاج الموصى بها',
  'survey.addRoutineToCart': 'أضيفي الروتين إلى السلة',
  'survey.satisfactionGuarantee': 'ضمان الرضا 100%',
  'survey.maybeLater': 'ربما لاحقاً',
  'survey.continueSurvey': 'تابعي الاستبيان',
  'survey.addedToCart': 'تمت إضافة المنتجات إلى السلة!',
  'survey.personalizedRoutine': 'روتينكِ المخصص جاهز',
  'survey.errorAddingToCart': 'خطأ في الإضافة إلى السلة',
  'survey.exclusiveDiscount': 'خصم 10% حصري لكِ!',
  'survey.couponCopied': 'تم نسخ رمز القسيمة!',
  'survey.useAtCheckout': 'استخدمي الرمز SURVEY10 عند الدفع للحصول على خصم 10%',
  'survey.bestDeal': 'أفضل عرض وجدته لكِ!',
  'survey.separatePrice': 'بشكل منفصل',
  'survey.yourPrice': 'سعركِ',
  'survey.youSave': 'توفيركِ',
  'survey.upgradeOption': 'تريدين نتائج أفضل؟',
  'survey.upgradeToBundle': 'ترقية إلى الروتين الكامل',
  'survey.upgradeSave': 'وفّري {amount} مع الطقم الكامل',
  'survey.addSingleToCart': 'أضيفي إلى السلة',

  // Survey loading messages
  'survey.loading.analyzing': 'أحلل ملف بشرتكِ...',
  'survey.loading.planning': 'أخطط لعلاج مخصص لكِ...',
  'survey.loading.matching': 'أبحث عن المنتجات المثالية لكِ...',
  'survey.loading.finalizing': 'شارفنا على الانتهاء...',

  'survey.q1.question': 'ما هو نوع بشرتكِ؟',
  'survey.q1.dry': 'جافة - بشرتي تشعر بالشد في أغلب الأحيان',
  'survey.q1.oily': 'دهنية - لامعة، خاصة في الجبهة والأنف',
  'survey.q1.combination': 'مختلطة - الجبهة والأنف دهنيتان، الخدود جافة',
  'survey.q1.normal': 'عادية - متوازنة، بدون مشاكل ملحوظة',
  'survey.q2.question': 'ما أكثر ما يزعجكِ في بشرتكِ؟',
  'survey.q2.aging': 'التجاعيد وخطوط التعبير',
  'survey.q2.acne': 'حب الشباب والبثور',
  'survey.q2.dullness': 'بشرة باهتة ولون غير موحد',
  'survey.q2.hyperpigmentation': 'بقع داكنة وفرط تصبغ',
  'survey.q3.question': 'ما مدى حساسية بشرتكِ؟',
  'survey.q3.very': 'حساسة جداً - تتفاعل مع معظم المنتجات',
  'survey.q3.somewhat': 'حساسة نوعاً ما - تفاعلات من حين لآخر',
  'survey.q3.not': 'غير حساسة - تتحمل معظم المنتجات',
  'survey.q4.question': 'ما مستوى ترطيب بشرتكِ؟',
  'survey.q4.veryDry': 'جافة جداً - تحتاج ترطيباً مستمراً',
  'survey.q4.somewhatDry': 'جافة قليلاً - تحتاج ترطيباً منتظماً',
  'survey.q4.balanced': 'متوازنة - لا جافة ولا دهنية',
  'survey.q4.wellHydrated': 'رطبة - مشدودة وصحية',
  'survey.q5.question': 'ما هي فئتكِ العمرية؟',
  'survey.q5.under25': 'أقل من 25',
  'survey.q5.25to35': '25-35',
  'survey.q5.35to45': '35-45',
  'survey.q5.over45': 'أكثر من 45',
  'survey.q6.question': 'كيف تصفين روتين العناية بالبشرة الحالي؟',
  'survey.q6.minimal': 'بسيط - تنظيف وترطيب فقط',
  'survey.q6.basic': 'أساسي - تنظيف، تونر، مرطب',
  'survey.q6.moderate': 'متوسط - يشمل سيرومات وعلاجات',
  'survey.q6.extensive': 'شامل - روتين عناية كوري كامل',
  'survey.q7.question': 'كيف تصفين ملمس بشرتكِ؟',
  'survey.q7.smooth': 'ناعمة ومتساوية',
  'survey.q7.rough': 'خشنة وذات ملمس غير متساوٍ',
  'survey.q7.uneven': 'غير متساوية مع بعض النتوءات',
  'survey.q7.bumpy': 'متعرجة مع مسام واضحة',
  'survey.q8.question': 'ما هدفكِ الرئيسي من العناية بالبشرة؟',
  'survey.q8.glow': 'الحصول على توهج البشرة الكوري',
  'survey.q8.antiAging': 'تقليل علامات الشيخوخة',
  'survey.q8.hydration': 'ترطيب عميق',
  'survey.q8.all': 'كل ما سبق',

  // Trust Strip
  'trust.clinicallyTested': 'مختبر سريرياً',
  'trust.happyCustomers': 'أكثر من 10,000 عميلة سعيدة',
  'trust.labFormula': 'تركيبة مختبر كوري',
  'trust.moneyBack': 'استرداد المال خلال 7 أيام',

  'science.title': 'PDRN من DNA السلمون — مدعوم علمياً',
  'science.subtitle': 'PDRN مثبت سريرياً بدراسات خضعت لمراجعة الأقران',
  'science.citation1': '"PDRN يعزز التئام الجروح وتجديد الأنسجة من خلال تنشيط مستقبل الأدينوزين A2A."',
  'science.source1': '— Journal of Cosmetic Dermatology, 2020',
  'science.citation2': '"PDRN المستخلص من السلمون يحسّن الترطيب والمرونة بشكل ملحوظ ويقلل عمق التجاعيد في التجارب السريرية."',
  'science.source2': '— International Journal of Molecular Sciences, 2021',

  'scienceInside.title': 'العلم بالداخل',
  'scienceInside.subtitle': 'لماذا تعمل هذه التركيبة — محركان قويان في سيروم واحد',
  'scienceInside.peptides.title': 'الببتيدات — المهندسون',
  'scienceInside.peptides.subtitle': '"رسائل ذكية، وليس كريماً سحرياً"',
  'scienceInside.peptides.point1': 'سلاسل قصيرة من الأحماض الأمينية تُرسل إشارات لبشرتكِ للتصرف كبشرة شابة ومتجددة',
  'scienceInside.peptides.point2': 'تدعم مظهراً أكثر شداً وتقلل ظهور التجاعيد الدقيقة مع مرور الوقت',
  'scienceInside.peptides.point3': 'تقوّي حاجز البشرة — البشرة تشعر بأقل هشاشة وأقل تفاعلاً',
  'scienceInside.peptides.point4': 'تأثير ذكي يتعاظم مع الاستخدام المنتظم، وليس معجزة ليوم واحد',
  'scienceInside.pdrn.title': 'PDRN — المجدِّد',
  'scienceInside.pdrn.subtitle': 'المكوّن الترميمي الرائد في عالم K-Beauty',
  'scienceInside.pdrn.point1': 'مقاطع DNA تتحدث بلغة التجديد والإصلاح',
  'scienceInside.pdrn.point2': 'يدعم جودة البشرة ويعزز مظهراً صحياً ومتماسكاً',
  'scienceInside.pdrn.point3': 'يهدئ البشرة المجهدة أو التفاعلية — احمرار أقل، توازن أكثر',
  'scienceInside.pdrn.point4': 'في السيروم: تحسين مستمر وذكي — ليس تغييراً جذرياً بين ليلة وضحاها',
  'scienceInside.combo.title': 'محركان، سيروم واحد',
  'scienceInside.combo.subtitle': 'توهج فوري + مكافحة شيخوخة تراكمية',
  'scienceInside.combo.point1': 'المحرك 1: "ترينه الآن" — ترطيب، انعكاس الضوء، ملمس أنعم',
  'scienceInside.combo.point2': 'المحرك 2: "ترينه مع الوقت" — شد، مرونة، إصلاح',
  'scienceInside.combo.point3': 'التأثير الفوري "واو" يجعلكِ تستمرين — الببتيدات وPDRN يفعلان الباقي',
  'scienceInside.combo.point4': 'النتيجة: بشرة تبدو متماسكة، هادئة ومصقولة',
  'scienceInside.tagline': 'الببتيدات تبني وتقوّي. PDRN يصلح ويهدئ. معاً، يمنحان بشرتكِ توهجاً فورياً وتجديداً على المدى الطويل.',

  // Science Inside — Default
  'scienceInside.default.subtitle': 'العلم وراء PDRN — كيف يغيّر بشرتكِ من الداخل',
  'scienceInside.default.tagline': 'PDRN يفعّل آلية الإصلاح الطبيعية للبشرة، يعزز تجديد الخلايا والترطيب العميق من أول استخدام.',

  // Default product FAQ
  'productContent.default.faq1.q': 'ما هو PDRN وكيف يعمل؟',
  'productContent.default.faq1.a': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون. يفعّل آلية الإصلاح الطبيعية للبشرة عبر مستقبل الأدينوزين A2A، ويعزز تجديد الخلايا وإنتاج الكولاجين والترطيب العميق.',
  'productContent.default.faq2.q': 'هل المنتج مناسب للبشرة الحساسة؟',
  'productContent.default.faq2.a': 'نعم! تركيباتنا مختبرة من أطباء الجلدية، لم تُختبر على الحيوانات، وخالية من البارابين والسلفات والفثالات. مصممة لتكون لطيفة على جميع أنواع البشرة، بما في ذلك البشرة الحساسة.',
  'productContent.default.faq3.q': 'كم من الوقت حتى تظهر النتائج؟',
  'productContent.default.faq3.a': 'معظم المستخدمات يلاحظن تحسناً في الترطيب وتوهجاً ملحوظاً من أول استخدام. للحصول على أفضل النتائج في خطوط التعبير وملمس البشرة، يُنصح بالاستخدام المنتظم لمدة 4-8 أسابيع.',

  // Science Inside — Masks
  'scienceInside.masks.subtitle': 'كيف تعمل ثلاثة مكونات قوية معاً في كل قناع قماشي',
  'scienceInside.masks.tagline': 'PDRN يصلح على المستوى الخلوي. فيتامين B12 يُنير. نياسيناميد يقوّي. 20 دقيقة — هذا كل ما تحتاجه بشرتكِ لامتصاص كل شيء.',
  'scienceInside.masks.card1.title': 'PDRN + فيتامين B12 — الثنائي المُنير',
  'scienceInside.masks.card1.subtitle': 'إصلاح خلوي يلتقي بتوهج مرئي',
  'scienceInside.masks.card1.point1': 'PDRN يفعّل تجديد الخلايا بينما فيتامين B12 يمنح تأثير إشراق فوري',
  'scienceInside.masks.card1.point2': 'معاً يعالجان البهتان من المصدر — وليس مجرد توهج سطحي',
  'scienceInside.masks.card1.point3': 'B12 مكوّن مغذٍ للبشرة مثبت يوحّد لون البشرة مع مرور الوقت',
  'scienceInside.masks.card1.point4': 'الثنائي يعمل بتآزر — PDRN يجدد، B12 يُنير',
  'scienceInside.masks.card2.title': 'نياسيناميد — بانِي الحاجز',
  'scienceInside.masks.card2.subtitle': 'يقوّي، يوازن، يحمي',
  'scienceInside.masks.card2.point1': 'يقوّي حاجز البشرة لحبس الرطوبة ومنع دخول المهيجات',
  'scienceInside.masks.card2.point2': 'يقلص المسام بشكل ملحوظ وينظم الدهون الزائدة',
  'scienceInside.masks.card2.point3': 'يقلل الاحمرار ويهدئ الالتهابات — مثالي للبشرة الحساسة',
  'scienceInside.masks.card2.point4': 'يعمل في جميع طبقات البشرة لتحسين الملمس واللون والمتانة',
  'scienceInside.masks.card3.title': 'تأثير القناع — 20 دقيقة من الامتصاص العميق',
  'scienceInside.masks.card3.subtitle': 'لماذا قناع القماش أفضل من السيروم العادي',
  'scienceInside.masks.card3.point1': 'القناع القماشي يخلق بيئة محكمة تمنع التبخر',
  'scienceInside.masks.card3.point2': 'المكونات الفعالة تُقدَّم بتركيز أعلى من السيرومات اليومية',
  'scienceInside.masks.card3.point3': 'امتصاص عميق — المكونات تخترق بشكل أعمق بفضل التلامس المطوّل مع البشرة',
  'scienceInside.masks.card3.point4': 'نتائج فورية ومرئية: بشرة أكثر امتلاءً ورطوبة وتوهجاً بعد استخدام واحد',

  // Science Inside — Cream
  'scienceInside.cream.subtitle': 'ثلاث تقنيات متقدمة تعمل ليلاً لتغيير بشرتكِ',
  'scienceInside.cream.tagline': 'الكولاجين يعيد بناء الهيكل. السيراميدات تحمي الحاجز. الكبسولات الذكية توصل كل شيء طوال الليل — لتستيقظي ببشرة متجددة ومشدودة.',
  'scienceInside.cream.card1.title': 'الكولاجين المتحلل — البنية',
  'scienceInside.cream.card1.subtitle': 'إعادة بناء من الداخل إلى الخارج',
  'scienceInside.cream.card1.point1': 'مُقسّم إلى أجزاء صغيرة يمكنها فعلاً اختراق البشرة — وليس مجرد البقاء على السطح',
  'scienceInside.cream.card1.point2': 'يدعم البنية الهيكلية للبشرة لشد ومرونة أفضل',
  'scienceInside.cream.card1.point3': 'يساعد في تقليل مظهر التجاعيد الدقيقة عن طريق الملء من الداخل',
  'scienceInside.cream.card1.point4': 'يعمل مع إنتاج الكولاجين الطبيعي لبشرتكِ — تعزيز وليس استبدال',
  'scienceInside.cream.card2.title': 'مركّب السيراميدات — الدرع',
  'scienceInside.cream.card2.subtitle': 'الحماية الطبيعية لبشرتكِ، معزّزة',
  'scienceInside.cream.card2.point1': 'السيراميدات تشكل 50% من حاجز البشرة الطبيعي — نحن نعوّض ما فُقد مع التقدم بالعمر',
  'scienceInside.cream.card2.point2': 'يحبس الرطوبة حتى 72 ساعة — لا مزيد من الشعور بالجفاف والشد ليلاً',
  'scienceInside.cream.card2.point3': 'يحمي من الأضرار البيئية: التلوث، الهواء الجاف، تغيرات درجة الحرارة',
  'scienceInside.cream.card2.point4': 'يقوّي الحاجز حتى تعمل المكونات الفعالة الأخرى بشكل أكثر فاعلية',
  'scienceInside.cream.card3.title': 'تقنية الكبسولات الذكية — إطلاق تدريجي',
  'scienceInside.cream.card3.subtitle': 'مكونات فعالة تُوصَل طوال الليل',
  'scienceInside.cream.card3.point1': 'كبسولات دقيقة تتفكك تدريجياً وتطلق المكونات الفعالة على مدى 8 ساعات',
  'scienceInside.cream.card3.point2': 'تمنع تحلل المكونات — تبقى قوية حتى لحظة إطلاقها',
  'scienceInside.cream.card3.point3': 'بشرتكِ تحصل على تدفق مستمر من التغذية بدلاً من جرعة واحدة كبيرة تتلاشى',
  'scienceInside.cream.card3.point4': 'استيقظي ببشرة متجددة ورطبة — الكبسولات قامت بعملها أثناء نومكِ',

  // Science Inside — Bundle
  'scienceInside.bundle.subtitle': 'لماذا ثلاثة منتجات معاً تقدم نتائج لا يمكن لأي منتج وحده تحقيقها',
  'scienceInside.bundle.tagline': 'الأقنعة تنظف وتغذي. السيروم يصلح ويُنير. الكريم يحبس كل شيء بالداخل. ثلاث خطوات، نظام واحد — 24 ساعة من تغيير البشرة المستمر.',
  'scienceInside.bundle.card1.title': 'ثلاث خطوات، نظام واحد',
  'scienceInside.bundle.card1.subtitle': 'كل منتج يهيئ البشرة للخطوة التالية',
  'scienceInside.bundle.card1.point1': 'الخطوة 1: أقنعة القماش تنظف بعمق وتغذي بـ PDRN مركّز + فيتامين B12',
  'scienceInside.bundle.card1.point2': 'الخطوة 2: السيروم يصلح، يشد ويمنح تأثير Glass Skin',
  'scienceInside.bundle.card1.point3': 'الخطوة 3: الكريم يحبس كل شيء بالكولاجين والسيراميدات وكبسولات الإطلاق التدريجي',
  'scienceInside.bundle.card1.point4': 'معاً: روتين كامل حيث كل خطوة تعزز السابقة',
  'scienceInside.bundle.card2.title': 'تأثير التآزر — أفضل معاً',
  'scienceInside.bundle.card2.subtitle': 'نتائج تراكمية تتعاظم مع الوقت',
  'scienceInside.bundle.card2.point1': 'استخدام المنتجات الثلاثة يخلق تأثيراً تراكمياً — النتائج تبني على بعضها',
  'scienceInside.bundle.card2.point2': 'PDRN في كل خطوة يعني تجديداً خلوياً مستمراً طوال الروتين',
  'scienceInside.bundle.card2.point3': 'طرق توصيل مختلفة (قناع، سيروم، كريم) تضمن وصول المكونات إلى كل طبقات البشرة',
  'scienceInside.bundle.card2.point4': 'العميلات يُبلّغن عن نتائج أسرع بشكل ملحوظ مع الروتين الكامل',
  'scienceInside.bundle.card3.title': 'تغطية 24 ساعة — نهاراً وليلاً',
  'scienceInside.bundle.card3.subtitle': 'بشرتكِ لا تبقى أبداً بدون حماية',
  'scienceInside.bundle.card3.point1': 'صباحاً: سيروم تحت المكياج للترطيب والحماية والتوهج طوال اليوم',
  'scienceInside.bundle.card3.point2': 'مساءً: قناع قماشي للتنظيف العميق والتغذية (2-3 مرات أسبوعياً)',
  'scienceInside.bundle.card3.point3': 'ليلاً: كريم بكبسولات إطلاق تدريجي تعمل أثناء نومكِ',
  'scienceInside.bundle.card3.point4': 'النتيجة: تجديد على مدار الساعة — بشرتكِ تتحسن 24/7',

  // What is PDRN (educational section)
  'whatIsPDRN.title': 'ما هو PDRN؟',
  'whatIsPDRN.subtitle': 'المكوّن الثوري الذي يغيّر عالم العناية بالبشرة — من العيادة إلى المنزل',
  'whatIsPDRN.origin.title': 'مستخلص من DNA السلمون',
  'whatIsPDRN.origin.subtitle': 'مكوّن مثبت في الطب التجميلي',
  'whatIsPDRN.origin.point1': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون — جزيء متوافق حيوياً يُستخدم في عيادات الأمراض الجلدية حول العالم',
  'whatIsPDRN.origin.point1.US': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون — جزيء متوافق حيوياً يُستخدم في عيادات الأمراض الجلدية في جميع أنحاء الولايات المتحدة',
  'whatIsPDRN.origin.point1.GB': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون — جزيء متوافق حيوياً يُستخدم في عيادات الأمراض الجلدية في جميع أنحاء المملكة المتحدة',
  'whatIsPDRN.origin.point1.AU': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون — جزيء متوافق حيوياً يُستخدم في عيادات الأمراض الجلدية في جميع أنحاء أستراليا',
  'whatIsPDRN.origin.point1.IL': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون — جزيء متوافق حيوياً يُستخدم في عيادات الأمراض الجلدية في جميع أنحاء إسرائيل',
  'whatIsPDRN.origin.point1.AE': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون — جزيء متوافق حيوياً يُستخدم في عيادات الأمراض الجلدية في جميع أنحاء الإمارات العربية المتحدة',
  'whatIsPDRN.origin.point1.FR': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون — جزيء متوافق حيوياً يُستخدم في عيادات الأمراض الجلدية في جميع أنحاء فرنسا',
  'whatIsPDRN.origin.point1.DE': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون — جزيء متوافق حيوياً يُستخدم في عيادات الأمراض الجلدية في جميع أنحاء ألمانيا',
  'whatIsPDRN.origin.point1.ES': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون — جزيء متوافق حيوياً يُستخدم في عيادات الأمراض الجلدية في جميع أنحاء إسبانيا',
  'whatIsPDRN.origin.point1.NO': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون — جزيء متوافق حيوياً يُستخدم في عيادات الأمراض الجلدية في جميع أنحاء النرويج',
  'whatIsPDRN.origin.point1.HR': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون — جزيء متوافق حيوياً يُستخدم في عيادات الأمراض الجلدية في جميع أنحاء كرواتيا',
  'whatIsPDRN.origin.point1.FI': 'PDRN (بولي ديوكسي ريبونوكليوتيد) يُستخلص من DNA السلمون — جزيء متوافق حيوياً يُستخدم في عيادات الأمراض الجلدية في جميع أنحاء فنلندا',
  'whatIsPDRN.origin.point2': 'مدعوم بدراسات سريرية بنتائج قابلة للقياس في الترطيب والمرونة',
  'whatIsPDRN.origin.point3': 'مركّب تجديدي طبيعي — بدون حشوات صناعية، بدون مواد كيميائية قاسية',
  'whatIsPDRN.howItWorks.title': 'تجديد على المستوى الخلوي',
  'whatIsPDRN.howItWorks.subtitle': 'يعمل حيث لا تصل المنتجات الأخرى',
  'whatIsPDRN.howItWorks.point1': 'يفعّل مستقبل الأدينوزين A2A — يحفّز عملية الإصلاح والتجديد الطبيعية لبشرتكِ',
  'whatIsPDRN.howItWorks.point2': 'يعزز إنتاج الكولاجين والإيلاستين من الداخل، وليس مجرد ترطيب سطحي',
  'whatIsPDRN.howItWorks.point3': 'يقلل الالتهابات ويهدئ البشرة المجهدة لبشرة صحية ومتوازنة أكثر',
  'whatIsPDRN.results.title': 'نتائج بمستوى العيادة في المنزل',
  'whatIsPDRN.results.subtitle': 'حتى وقت قريب — فقط في العيادات',
  'whatIsPDRN.results.point1': 'حتى وقت قريب، كانت علاجات PDRN متاحة فقط في عيادات الأمراض الجلدية الفاخرة بأسعار مرتفعة',
  'whatIsPDRN.results.point2': 'تركيباتنا تقدم نفس المكوّن الفعّال بصيغة للاستخدام اليومي يمكنكِ تطبيقها في المنزل',
  'whatIsPDRN.results.point3': '+100% تحسن في الترطيب مُقاس سريرياً — تحسن مرئي من أول استخدام',

  // Proven Results
  'provenResults.title': 'نتائج مثبتة',
  'provenResults.stat1.value': '+100%',
  'provenResults.stat1.label': 'تحسن في الترطيب',
  'provenResults.stat1.sub': 'مُقاس سريرياً',
  'provenResults.stat2.value': '93%',
  'provenResults.stat2.label': 'بشرة أكثر نعومة',
  'provenResults.stat2.sub': 'أُبلغ عنها خلال 4 أسابيع',
  'provenResults.stat3.value': '4.9/5',
  'provenResults.stat3.label': 'تقييم العملاء',
  'provenResults.stat3.sub': 'المعدل لجميع المنتجات',
  'provenResults.stat4.value': '+10,000',
  'provenResults.stat4.label': 'عميلات سعيدات',
  'provenResults.stat4.sub': 'حول العالم',
  'provenResults.stat4.sub.US': 'في جميع أنحاء الولايات المتحدة',
  'provenResults.stat4.sub.GB': 'في جميع أنحاء المملكة المتحدة',
  'provenResults.stat4.sub.AU': 'في جميع أنحاء أستراليا',
  'provenResults.stat4.sub.IL': 'في جميع أنحاء إسرائيل',
  'provenResults.stat4.sub.AE': 'في جميع أنحاء الإمارات العربية المتحدة',
  'provenResults.stat4.sub.FR': 'في جميع أنحاء فرنسا',
  'provenResults.stat4.sub.DE': 'في جميع أنحاء ألمانيا',
  'provenResults.stat4.sub.ES': 'في جميع أنحاء إسبانيا',
  'provenResults.stat4.sub.NO': 'في جميع أنحاء النرويج',
  'provenResults.stat4.sub.HR': 'في جميع أنحاء كرواتيا',
  'provenResults.stat4.sub.FI': 'في جميع أنحاء فنلندا',

  // Comparison Table
  'comparison.title': 'PDRN مقابل العناية العادية',
  'comparison.headerRegular': 'عناية عادية',
  'comparison.headerPDRN': 'PDRN SKIN',
  'comparison.row1.criteria': 'آلية العمل',
  'comparison.row1.regular': 'ترطيب سطحي',
  'comparison.row1.pdrn': 'تجديد على المستوى الخلوي',
  'comparison.row2.criteria': 'المكوّن الفعّال',
  'comparison.row2.regular': 'ببتيدات عامة',
  'comparison.row2.pdrn': 'PDRN (DNA السلمون)',
  'comparison.row3.criteria': 'النتائج',
  'comparison.row3.regular': 'أسابيع حتى تظهر',
  'comparison.row3.pdrn': 'مرئية من أول استخدام',
  'comparison.row4.criteria': 'التقنية',
  'comparison.row4.regular': 'تركيبات تقليدية',
  'comparison.row4.pdrn': 'تقنية بمستوى العيادة',
  'comparison.row5.criteria': 'الإثبات السريري',
  'comparison.row5.regular': 'ادعاءات تسويقية',
  'comparison.row5.pdrn': 'مختبر سريرياً +100% ترطيب',

  'faq.sectionTitle': 'الأسئلة الشائعة',
  '404.title': 'الصفحة غير موجودة',
  '404.subtitle': 'الصفحة التي تبحثين عنها غير موجودة أو تم نقلها.',
  '404.backHome': 'العودة إلى الرئيسية',
  '404.popularProducts': 'منتجات شائعة',

  'product.disclaimer': '*الصور للتوضيح فقط. قد تختلف النتائج من شخص لآخر حسب نوع البشرة وطريقة الاستخدام. المنتج غير مخصص لتشخيص أو علاج أو الوقاية من حالات طبية. يُنصح بإجراء اختبار حساسية على منطقة مخفية قبل الاستخدام الكامل لأول مرة. في حال حدوث حساسية، يجب التوقف عن الاستخدام. في حال كانت الحساسية شديدة، يجب مراجعة الطبيب. قد يقوم المورّد بتغيير عبوة المنتج وشكله من وقت لآخر؛ المنتج هو نفسه.',
  'product.shippingMarquee': 'شحن مجاني للطلبات التي تزيد عن {amount} في جميع أنحاء الإمارات',
  'product.inStockReady': 'متوفر في المخزون للشحن الفوري',

  // Terms agreement
  'product.termsAgreementBefore': 'بتصفح الموقع والشراء منه فإنكِ توافقين على',
  'product.termsLink': 'شروط الاستخدام',
  'product.termsAgreementAfter': 'للموقع',

  'announcement.freeShipping': '✨ شحن مجاني للطلبات التي تزيد عن {amount} في جميع أنحاء الإمارات',
  'announcement.close': 'إغلاق',
  'urgency.limitedOffer': 'عرض محدود',
  'urgency.endsIn': 'ينتهي خلال',

  // Blog
  'blog.title': 'المدونة',
  'blog.subtitle': 'أدلة عناية بالبشرة احترافية، علم PDRN ونصائح من العناية الكورية',
  'blog.metaDescription': 'اقرئي أدلتنا الاحترافية عن عناية PDRN، علم DNA السلمون، روتينات Glass Skin ونصائح من العناية الكورية بالبشرة.',
  'blog.readMore': 'اقرئي المزيد',
  'blog.minRead': 'دقائق قراءة',
  'blog.badge': 'عناية بالبشرة مدعومة بالعلم',
  'blog.chip.antiAging': 'مكافحة الشيخوخة',
  'blog.chip.hydration': 'ترطيب',
  'blog.chip.sensitiveSkin': 'البشرة الحساسة',
  'blog.chip.nightRoutine': 'روتين مسائي',
  'blog.chip.ingredients': 'المكونات',
  'blog.chip.layering': 'الطبقات',
  'blog.chip.glassSkin': 'بشرة زجاجية',
  'blog.chip.pdrnScience': 'علم PDRN',
  'blog.relatedArticles': 'مقالات ذات صلة',
  'blog.recommendedProducts': 'منتجات موصى بها',
  'blog.latestArticles': 'الجديد في مدونتنا',
  'blog.latestSubtitle': 'أدلة عناية PDRN احترافية ونصائح من العناية الكورية بالبشرة',
  'blog.viewAll': 'جميع المقالات',
  'blog.statsArticles': 'مقالات',
  'blog.statsLanguages': 'لغات',
  'blog.statsVersions': 'نسخة مترجمة',
  'blog.availableIn': 'متاح بـ11 لغة',
  'blog.avgReadTime': 'متوسط 5 دقائق قراءة',

  // SEO meta (homepage)
  'seo.homeTitle': 'PDRN للعناية بالبشرة | سيروم DNA السلمون الكوري، أقنعة وكريم | Glass Skin',
  'seo.homeDescription': 'عناية PDRN بالبشرة بتقنية DNA السلمون الكوري. سيروم PDRN، أقنعة قماشية وكريم كبسولات لتأثير Glass Skin. مثبت سريرياً مع شحن مجاني.',

  // SEO product titles & descriptions
  'seo.productTitle.pink-glow-serum-with-pdrn-peptides': 'سيروم PDRN بحمض DNA السلمون والببتيدات | عناية PDRN بالبشرة',
  'seo.productDescription.pink-glow-serum-with-pdrn-peptides': 'اشترِ سيروم PDRN بحمض DNA السلمون والببتيدات. سيروم كوري لتأثير Glass Skin يعزز الكولاجين ويملّس التجاعيد. شحن مجاني.',
  'seo.productTitle.pdrn-pink-sheet-masks-10-pack': 'أقنعة PDRN القماشية 10 قطع | أقنعة كورية بحمض DNA السلمون | PDRN',
  'seo.productDescription.pdrn-pink-sheet-masks-10-pack': 'اشترِ أقنعة PDRN القماشية المشبعة بسيروم DNA السلمون. 10 أقنعة كورية للوجه لتأثير Glass Skin مع PDRN وفيتامين B12 والنياسيناميد.',
  'seo.productTitle.smart-capsule-cream-with-collagen': 'كريم كبسولات PDRN بالكولاجين | عناية كورية | PDRN للبشرة',
  'seo.productDescription.smart-capsule-cream-with-collagen': 'اشترِ كريم كبسولات PDRN بالكولاجين والنياسيناميد. كريم كوري مضاد للشيخوخة بتقنية DNA السلمون لترطيب عميق وشد البشرة.',
  'seo.productTitle.complete-pdrn-trio-bundle': 'مجموعة PDRN الكاملة — سيروم وأقنعة وكريم | عناية PDRN بالبشرة',
  'seo.productDescription.complete-pdrn-trio-bundle': 'اشترِ مجموعة العناية PDRN الكاملة بالسيروم و10 أقنعة والكريم. وفّر حتى 53% على العناية الكورية بحمض DNA السلمون.',

  // Internal linking
  'seo.explorePDRN': 'اكتشف عناية PDRN بالبشرة',
  'seo.anchor.serumBenefits': 'فوائد سيروم PDRN',
  'seo.anchor.howPDRNWorks': 'كيف يعمل PDRN',
  'seo.anchor.masksVsTraditional': 'أقنعة PDRN مقابل التقليدية',
  'seo.anchor.glassSkinGuide': 'دليل Glass Skin',
  'seo.anchor.koreanSecret': 'سر العناية الكورية',
  'seo.anchor.pdrnVsRegular': 'PDRN مقابل العناية العادية',
};
